import { render, staticRenderFns } from "./Recettes.vue?vue&type=template&id=6fcfb262"
import script from "./Recettes.vue?vue&type=script&lang=js"
export * from "./Recettes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports